module.exports = __webpack_public_path__ + "img/gd-vertical-pipe.55cb2f6c.svg";